import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, TrendingUp, Calendar, IndianRupee } from "lucide-react";

const QUICK = [
  { icon: TrendingUp, label: "2.4× revenue uplift" },
  { icon: Calendar, label: "Live in 30 days" },
  { icon: IndianRupee, label: "Zero upfront fees" },
];

export default function OwnerStrip() {
  const navigate = useNavigate();
  return (
    <section className="bg-[#FAFAF8] py-16 md:py-20" data-testid="owner-strip-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="bg-[#E8F2EC] border border-[#0E2E24]/10 rounded-[28px] overflow-hidden grid lg:grid-cols-12 gap-0 items-center">
          {/* Image */}
          <div className="lg:col-span-5 relative aspect-[4/3] lg:aspect-auto lg:h-full min-h-[280px]">
            <img
              src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&q=85&w=1400"
              alt="A managed Appy farmhouse"
              className="img-cover"
            />
          </div>

          {/* Copy */}
          <div className="lg:col-span-7 p-8 md:p-12">
            <div className="kicker mb-3">For property owners</div>
            <h2 className="font-sora text-3xl md:text-4xl font-semibold tracking-tight text-[#0E2E24] leading-[1.1]">
              Own a farmhouse? Let Appy Stays
              <br />fill your calendar.
            </h2>
            <p className="mt-4 max-w-xl text-[#5B6B63] leading-relaxed">
              We rebrand, market, sell and operate your property end-to-end. You keep ownership and earn a transparent monthly revenue share.
            </p>

            <div className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-sm font-sora text-[#0E2E24]">
              {QUICK.map((q) => (
                <span key={q.label} className="flex items-center gap-1.5"><q.icon size={15} className="text-[#1F5A43]" /> {q.label}</span>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <Button
                onClick={() => navigate("/partner")}
                className="bg-[#0E2E24] hover:bg-[#1F5A43] text-[#FAFAF8] rounded-full px-7 py-6 font-sora font-medium gap-2"
                data-testid="owner-strip-list-btn"
              >
                List Your Property <ArrowRight size={16} />
              </Button>
              <Button
                variant="outline"
                onClick={() => navigate("/partner#how-it-works")}
                className="rounded-full px-7 py-6 border-[#0E2E24]/20 text-[#0E2E24] bg-white hover:bg-[#FAFAF8] font-sora font-medium"
                data-testid="owner-strip-learn-btn"
              >
                See how it works
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
